import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AuthInterface from './AuthInterface';

const initialState: any = {
  isEnabled: false,
};

const authSlice = createSlice({
  name: 'exception',

  initialState,
  reducers: {
    setException: (state: any, action: PayloadAction<AuthInterface>) => {
      const payload = action.payload;
      state.isEnabled = payload;
    },
  },
});

export const { setException } = authSlice.actions;

export default authSlice.reducer;
